import React from 'react';

const Footer = () => {
  return (
    <footer className=''>
      <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-300 lg:my-8" />
      <span className="block text-sm text-gray-500 dark:text-gray-400 my-8 px-4 text-center break-words max-w-screen-sm mx-auto">
        © 2026 <a href="https://aranview.ie/" className="hover:underline">Aran View Filling Station</a>. All Rights Reserved.
      </span>
    </footer>
  );
};

export default Footer;
